export const DISPONIBILIDADE_VIAGEM = ["SIM", "NAO", "ENVENTUALMENTE"] as const;

export type DISPONIBILIDADE_VIAGEM_TYPE =
  (typeof DISPONIBILIDADE_VIAGEM)[number];
